// ChatWindow.tsx
import React from 'react';
import { Container, Nav } from 'react-bootstrap';

const ChatWindow: React.FC = () => {
  return (
    <Container fluid className="p-0" style={{ height: '100vh', background: '#fff' }}>
      {/* Header */}
      <div
        className="d-flex align-items-center p-3"
        style={{ backgroundColor: '#0f5132', color: 'white' }}
      >
        <span className="me-2" style={{ fontSize: '20px', fontWeight: 'bold' }}>
          ✔
        </span>
        <h5 className="mb-0">SkipScreen</h5>
      </div>

      {/* Nav */}
      <Nav fill variant="tabs" defaultActiveKey="messages" className="bg-white shadow-sm">
        <Nav.Item>
          <Nav.Link eventKey="questions">Questions</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="messages">Messages</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="contacts">Contacts</Nav.Link>
        </Nav.Item>
      </Nav>

      {/* Chat messages */}
      <div
        style={{
          padding: '1rem',
          overflowY: 'auto',
          height: 'calc(100vh - 150px)',
        }}
      >
        <div className="p-2 mb-2 rounded bg-light" style={{ maxWidth: '75%' }}>
          other job I had..took a little longer than expected but will be at yours soon
        </div>

        <div className="p-2 mb-2 rounded bg-light" style={{ maxWidth: '75%' }}>
          May be a little late
        </div>

        <div className="d-flex justify-content-end">
          <div className="p-2 mb-2 rounded" style={{ backgroundColor: '#e9f7ef', maxWidth: '75%' }}>
            No worries
          </div>
        </div>

        <p className="text-center text-muted small">Justin worked 1:30 hours</p>

        <div className="p-2 mb-2 rounded bg-light" style={{ maxWidth: '75%' }}>
          Usually have a 2 hour minimum but you were close to the house so took off time. Thanks for
          choosing me! Appreciate the business and hope you have a great rest of your day
        </div>

        <div className="p-2 mb-2 rounded bg-light" style={{ maxWidth: '75%' }}>
          Here
        </div>
      </div>
    </Container>
  );
};

export default ChatWindow;
